var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-component-container"},[_c('special-competition-selector-panel'),_c('line-divider',{staticClass:"line-divider"}),_c('div',{staticClass:"content-wrap"},[_c('player-contact')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }